import { Box, Text } from "@chakra-ui/react";

interface PasswordErrorsProps {
  errors: string[];
}

export function PasswordErrors({ errors }: PasswordErrorsProps) {
  if (errors.length === 0) {
    return null;
  }

  return (
    <Box bg="#FEF2F2" borderRadius="8px" padding="12px 16px" mt="14px">
      <Text
        fontFamily="General Sans"
        fontSize="14px"
        fontWeight="400"
        color="#0B0E10"
        mb="8px"
      >
        This password is invalid because:
      </Text>
      <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
        {errors.map((error) => (
          <li key={error} style={{ display: "flex", marginBottom: "4px" }}>
            <span
              style={{
                color: "#B91C1C",
                fontSize: "20px",
                marginRight: "12px",
                lineHeight: "1.2",
              }}
            >
              •
            </span>
            <span
              style={{
                fontFamily: "General Sans",
                fontSize: "14px",
                color: "#B91C1C",
                flex: 1,
              }}
            >
              {error}
            </span>
          </li>
        ))}
      </ul>
    </Box>
  );
}
